import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Navbar from "../../../components/Navbar";
import CategoryCarousel from "../../../components/CampaignOverview/Categories";
import CampaignMetrics from "../../../components/CampaignOverview/CampaignMetrics";
import RecentCampaigns from "../../../components/CampaignOverview/RecentCampaigns";
import { campaignsRequest } from "../../../requests/vendor/CampaignsRequest";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import NetworkStats from "../../../components/CampaignOverview/NetworkStats";
import SubscribersDistributionList from "../../../components/CampaignOverview/SubscribersDistributionList";
import DashboardRequests from "../../../requests/vendor/DashboardRequests";

const CampaignOverview = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [networkData, setNetworkData] = useState([]);
  const [RecentCampaignsList, setRecentCampaignsList] = useState([]);
  const [subscribersDistributionList, setSubscribersDistributionList] =
    useState([]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setIsLoading(true);
        const [
          categoryResponse,
          networkResponse,
          recentCampaignsResponse,
          subscribersDistributionResponse,
        ] = await Promise.all([
          campaignsRequest.campaignCategorySubscribersStats(),
          campaignsRequest.getStatsByNetwork(),
          DashboardRequests.getRecentDeals(3),
          campaignsRequest.getSubscribersDistributionByRegion(),
        ]);

        if (categoryResponse?.data?.in_error === false) {
          setCategoryData(categoryResponse?.data?.data);
        } else {
          toast.error(
            categoryResponse?.data?.reason ||
              "Sorry the subscriber count could not be fetched"
          );
        }

        if (networkResponse?.data?.in_error === false) {
          setNetworkData(networkResponse?.data?.data);
        } else {
          toast.error(
            networkResponse?.data?.reason ||
              "Sorry the network stats could not be fetched"
          );
        }
        if (recentCampaignsResponse?.data?.in_error === false) {
          setRecentCampaignsList(
            recentCampaignsResponse?.data?.data
              ? recentCampaignsResponse?.data?.data.slice(
                  Math.max(0, recentCampaignsResponse?.data?.data.length - 3)
                )
              : []
          );
        } else {
          toast.error(
            recentCampaignsResponse?.data?.reason ||
              "Sorry the recent campaigns could not be fetched"
          );
        }
        if (subscribersDistributionResponse?.data?.in_error === false) {
          setSubscribersDistributionList(
            subscribersDistributionResponse?.data?.data
          );
        } else {
          toast.error(
            subscribersDistributionResponse?.data?.reason ||
              "Sorry the subscribers distribution could not be fetched"
          );
        }
      } catch (error) {
        toast.error("An error occurred while fetching the stats");
      } finally {
        setIsLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Navbar page="What We Offer You" />
      <div className="overflow-x-hidden min-h-screen bg-white">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="w-full"
        >
          <CategoryCarousel
            categoryData={categoryData}
            networkData={networkData}
          />
          <NetworkStats networkData={networkData} />
          {/* <SubscribersDistributionList subscribersDistributionList={subscribersDistributionList} /> */}
          <CampaignMetrics recentCampaignsList={RecentCampaignsList} />
          {/* <RecentCampaigns recentCampaignsList={RecentCampaignsList} /> */}
        </motion.div>
      </div>
    </>
  );
};

export default CampaignOverview;
